import React from "react";
import { Box } from "@mui/material";
import LGModalCrud from "../LGCrud/LGModalCrud";
import { deleteOperationProcess, getOperationProcessList } from "../../api/operationProcess";
import OperationProcessForm from "./OperationProcessForm";

export default function OperationProcessCrud({ companyId }) {
  if (!companyId) return null;

  return (
    <Box width={"100%"}>
      <LGModalCrud
        props={{
          actions: ["create", "update", "delete"],
          data: { companyId },
          fetchFunction: getOperationProcessList,
          deleteFunction: deleteOperationProcess,
          columns: [
            { field: "name", headerName: "Nombre", flex: 0.3 },
            { field: "description", headerName: "Descripción", flex: 0.5 },
            {
              field: "steps",
              headerName: "Pasos",
              flex: 0.2,
              valueGetter: (value, row) => row.steps?.length ?? 0,
            },
          ],
          addModalData: {
            header: "Nuevo Proceso de Operación",
            body: <OperationProcessForm companyId={companyId} />,
          },
          editModalData: {
            header: "Editar Proceso de Operación",
            body: <OperationProcessForm companyId={companyId} />,
          },
        }}
      />
    </Box>
  );
}
